import Base from './base-button.component'

export default Base
